import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]

  connect() {
    this.listTarget.addEventListener("click", (event) => {
      if (event.target && event.target.matches("li")) {
        this.selectSuggestion(event.target.dataset.value);
      }
    });

    document.addEventListener("click", (event) => {
      if (!this.element.contains(event.target)) {
        this.hideSuggestions();
      }
    });
  }

  updateSuggestions() {
    const query = this.inputTarget.value.trim().toLowerCase();
    const suggestions = this.listTarget.querySelectorAll("li[data-value]");

    if (query.length === 0) {
      this.showSuggestions();
      return;
    }

    let hasMatch = false;

    suggestions.forEach((li) => {
      if (li.dataset.value.toLowerCase() === "other") {
        li.style.display = "block";
        return;
      }

      const label = li.dataset.value.toLowerCase();
      const isMatch = label.includes(query);

      li.style.display = isMatch ? "block" : "none";
      if (isMatch) {
        hasMatch = true;
      }
    });

    const hasVisibleMakers = Array.from(suggestions).some(
      (li) =>
        li.dataset.value.toLowerCase() !== "other" && li.style.display === "block",
    );

    const otherOption = this.listTarget.querySelector("[data-maker-suggestions-target='otherOption']");
    if (otherOption) {
      otherOption.style.display = "block";
    }

    const shouldShowList = hasVisibleMakers || hasMatch || (otherOption && otherOption.style.display === "block");
    this.listTarget.style.display = shouldShowList ? "block" : "none";

    this.inputTarget.setCustomValidity("");
  }

  showSuggestions() {
    const query = this.inputTarget.value.trim().toLowerCase();

    if (query.length === 0) {
      this.listTarget.querySelectorAll("li[data-value]").forEach((li) => {
        li.style.display = "block";
      });
      this.listTarget.style.display = "block";
      this.inputTarget.setCustomValidity("");
      return;
    }

    this.updateSuggestions();
  }

  validate(event) {
    const selected = this.inputTarget.value.trim().toLowerCase();
    const options = Array.from(this.listTarget.querySelectorAll("li[data-value]")).map((li) =>
      li.dataset.value.toLowerCase(),
    );

    if (!options.includes(selected)) {
      event.preventDefault();
      this.inputTarget.setCustomValidity("Choose a maker from the list or select Other.");
      this.inputTarget.reportValidity();
      this.updateSuggestions();
      return false;
    }

    this.inputTarget.setCustomValidity("");
    return true;
  }

  selectSuggestion(value) {
    this.inputTarget.value = value;
    this.inputTarget.setCustomValidity("");
    this.hideSuggestions();
  }

  hideSuggestions() {
    this.listTarget.style.display = "none";
  }
}
